import React from 'react';
import NoResult from './questionChartsNoResult';
import { BarChart } from '@citrus/chart';
import {
  Table,
  Tbody,
  Td,
  Tr,
  Th,
  Thead,
} from '@citrus/data-table';
import { ZeroState } from '@citrus/zero-state';

const StackRankingChart = ({ responses, number, responseCount, isSummary }) => {
  const tableConfig = {
    page: 1,
    size: Number.MAX_SAFE_INTEGER,
    sorting: {
      column: '',
      direction: '',
      sort: ''
    }
  }
  if(responses === null || responses.length === 0 || typeof(responses) !== typeof([])) {
    return (<NoResult number={number}/>);
  }

  const stats = [];
  const categories = [];
  responses.sort((a, b) => Number(b.sum) - Number(a.sum));
  responses.forEach((response, index) => {
    var average = response.sum/responseCount;
    var series = [];
    for(let i=0; i < index; i++){
      series.push(0)
    }
    series.push(average);
    stats.push({name: response.text, series: series});
    categories.push(response.text);
  });

  return (
    <React.Fragment>
      <BarChart
        config={{
          plotOptions: {
              series: {
                  stacking: 'normal',
                  showInLegend: false
              }
          },
        }}
        data={stats}
        xAxis={{ categories: categories }}
        yAxis={{ title: {text: "Average"}}}
        automationId={"question-" + number + "-stackrank-chart"}
      />
      {
        !isSummary &&
        <Table.Core
          automationId={"question-" + number + "-stack-rank-summation-chart"}
          itemCount={responses.length}
          onChangePage={() => {}}
          page={tableConfig.page}
          pageSize={tableConfig.size}
          css={"div > div > div > span { display: none }"}
          renderZeroState={() => <ZeroState type="insufficientdata" />}
        >
          <Thead>
            <Th column="item">Item</Th>
            {responses.map((response, index) => {
              return (<Th key={"rank-" + index + "-stack-rank-column"} column={"rank-" + (index + 1)}>Rank {(index + 1)}</Th>);
            })}
            <Th column="responses">Responses</Th>
            <Th column="score">Score</Th>
          </Thead>
          <Tbody>
            {responses.map((response, index) => {
              var average = response.sum/responseCount;
              return (
                <Tr key={"question-" + index + "-stack-rank-response-data"}>
                  <Td>{response.text}</Td>
                  {response.byQuestionRank && response.byQuestionRank.map((rank) => {
                    if(rank === 0) {
                      return (<Td> - </Td>);
                    }
                    var percentage = ((100 * rank)/responseCount).toFixed(0);
                    return (<Td>{percentage}% ({rank})</Td>);
                  })}
                  <Td>{responseCount}</Td>
                  <Td>{average * 10 % 1 > 0 ? (average).toFixed(0) : average}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table.Core>
      }
    </React.Fragment>
  )
}

export default StackRankingChart;